import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the LoggerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoggerProvider {

  constructor(public http: HttpClient) {
    console.log('Hello LoggerProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/logger/logger.ts